import template from './timesheet-grid.html';
import controller from './timesheet-grid.controller';

let TimesheetGridComponent = {
  restrict: 'E',
  bindings: {
    timesheet: '<'
  },
  template,
  controller
};

export default TimesheetGridComponent;




// WEBPACK FOOTER //
// ./client/common/directives/timesheet-grid/timesheet-grid.component.js